<template>
	<div class="margin-left">
		<div class="cont bg-white">
			<div class="bg-white margin-lr dvly padding-tb">
				<div class="flex align-center justify-center">
					<div class="round nocheck check"></div>
					<div class="noxian"></div>
					<div class="round nocheck" :class="is_real > 0?'check':''"></div>
					<div class="noxian"></div>
					<div class="round nocheck " :class="is_real == 2?'check':is_real == 3?'noguo':''"></div>
				</div>
				<div class="flex justify-between" style="padding-left: 60rpx;padding-right: 60rpx;width: 545px;margin: 21px auto;">
					<div class="text-sm text-666">上传证件</div>
					<div class="text-sm text-666">信息审核</div>
					
					<div class="text-sm text-666" v-if="is_real == 3">审核不过</div>
					<div class="text-sm text-666" v-else>审核通过</div>
				</div>
			</div>
			<div class="form">
				<el-form :model="info" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
					<el-form-item label="姓名" prop="name">
						<el-input v-model="info.nickname" placeholder="请输入真实姓名"></el-input>
					</el-form-item>
					<el-form-item label="证件类型" prop="name">
						<el-input :disabled="true" placeholder="身份证"></el-input>
					</el-form-item>
					<el-form-item label="证件号" prop="photo">
						<el-input type="text" v-model="info.idnum" placeholder="请输入证件号码"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<p class="plan" v-if="is_real == 0" @click="gonum">没带身份证？<span class="text-theme">直接身份证号认证</span></p>
			<p class="plan text-theme" v-if="is_real == 2">当前实名信息已审核通过</p>
			<div class="btns text-white" @click="sub" v-if="is_real == 0||is_real == 3">确认提交</div>
			<p class="margin-top">如有疑问请联系平台客服：400-212-22</p>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				is_real: 0,//0未申请，1是申请中，2是通过，3驳回
				imageUrl:'',//上传身份证人像面
				idimageUrl:'',//上传身份证国徽面
				info:{
					nickname:'',//姓名
					idnum:'',//证件号码
				},
				rules: {
					nickname: [ { message: '请输入真实姓名', trigger: 'blur' },],
					
					idnum: [{
						message: '请输入证件号码',
						trigger: 'blur'
					}]
				}
			}
		},
		created() {
			this.getReal()
		},
		methods: {
			/**
			 * 跳转对应组件
			 * type string 对应组件名
			 * */
			fect(type){
				let typeq = {
					type:type,
					typeone:''
				}
				this.$emit('gettype',typeq)
			},
			/**
			 * 上传身份证人像面
			 * */
			handleAvatarSuccess(file){
				this.imageUrl = file.data.url;
			},
			beforeAvatarUpload(){},
			/**
			 * 上传身份证国徽面
			 * */
			handleSuccess(file){
				this.idimageUrl = file.data.url;
			},
			beforeUpload(){},
			/**
			 * 确认提交
			 * */
			sub(){
				this.ajax('post', '/api/pc/userReal/certification', {
					name:this.info.nickname,
					idcard:this.info.idnum,
				}, res => {
					console.log(res);
					if(res.status == 200){
						this.$message('提交成功');
					}else{
						this.$message(res.msg);
					}
				})
			},
			/**
			 * 获取实名进度
			 * */
			getReal(){
				this.ajax('get', '/api/pc/userReal/getReal', {
					type:1,
				}, res => {
					console.log(res);
					if(res.status == 200){
						this.info.nickname = res.data.name
						this.info.idnum = res.data.idcard
						this.is_real = res.data.is_real	
					}else{
						this.$message(res.msg);
					}
				})
			},
			gonum(){
				
			}
		}
	}
</script>

<style scoped lang="less">
	.cont{
		width:920px;
		padding-top: 80px;
		padding-bottom: 80px;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2);
		border-radius: 20px;
	}
	
	.matop50{
		margin-top: 50px;
	}
	.form{
		padding: 0 60px 0 35px;
	}
	.plan{
		margin-top: 100px;
		margin-bottom:50px;
	}
	
	.btns{
		width: 383px;
		height: 60px;
		line-height: 60px;
		background: #09827B;
		box-shadow: 3px 4px 38px 2px rgba(9,130,123,0.2);
		border-radius: 30px;
		margin: 40px auto 40px;
	}
	/deep/ .el-input__inner{
		background: rgba(230,230,230,0.3);
		border: 1px solid #E6E6E6;
		height: 54px;
	}
	// 步骤器
	.nocheck{
		width: 26px;
		height: 26px;
		border-radius: 50%;
		background: rgba(11, 131, 124, 0.2);
	}
	.check{
		position: relative;
		&::after{
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			width: 13px;
			height: 13px;
			border-radius: 50%;
			background: rgba(11, 131, 124,1);
			content: '';
		}
	}
	.noguo{
		position: relative;
		background: rgba(242, 16, 64, 0.2) !important;
		&::after{
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			width: 13px;
			height: 13px;
			border-radius: 50%;
			background: rgba(242, 16, 64, 1);
			content: '';
		}
	}
	.noxian{
		width: 209px;
		height: 2px;
		background: rgba(11, 131, 124, 0.2);
	}
	//步骤器
</style>



// WEBPACK FOOTER //
// src/components/my/attestation/idnumber.vue